import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import {STUDENT_CLICK_EVENTS} from '@/tools/values/student.values';
import Organization from '@/tools/models/organization.model';
import EdStudentListClassComponent from '@/tools/components/ed-student-admin/ed-student-list-class/ed-student-list-class.component.vue';

@Component({
  name: 'ed-student-info',
  components: {
    EdStudentListClass: EdStudentListClassComponent
  }
})
export default class EdStudentInfoComponent extends Vue {

  /* Props */
  @Prop() readonly organization: Organization;
  @Prop() readonly userItem: any;

  /* Data */
  /* Computed */
  private getAddressProp(key:string){
    if (this.hasAddress()){
      return this.userItem.addresses[0][key];
    }
    return '';
  }

  getAddress(){
    let user = this.userItem;
    let res = [];
    if (this.hasAddress()){
      if (user.addresses[0].address1){
        res.push({id:1, address: user.addresses[0].address1});
      }
      if (user.addresses[0].address2){
        res.push({id:2, address: user.addresses[0].address2});
      }
      if (user.addresses[0].address3){
        res.push({id:3, address: user.addresses[0].address3});
      }
    }
    return res;
  }

  getPhone(){
    return this.hasPhones() ? this.userItem.phones:[]
  }
  /* Methods */
  hasAddress(){
    return Array.isArray(this.userItem.addresses)
        &&  this.userItem.addresses.length > 0;
  }
  hasPhones(){
    return Array.isArray(this.userItem.phones)
        &&  this.userItem.phones.length > 0;
  }

  private goToList() {
    this.$edEventBus.$emit(STUDENT_CLICK_EVENTS.HIDE_STUDENT);
  }
}
